import { render, staticRenderFns } from "./email.vue?vue&type=template&id=2f1bb8c1&scoped=true&"
import script from "./email.vue?vue&type=script&lang=ts&"
export * from "./email.vue?vue&type=script&lang=ts&"
import style0 from "./email.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./email.vue?vue&type=style&index=1&id=2f1bb8c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bb8c1",
  null
  
)

export default component.exports